import { articles } from "@/mocks/articles";

export default function ArticleGrid() {
  return (
    <section className="relative w-full py-20 md:py-28 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-4">
            <div>
              <span className="inline-flex items-center gap-2 px-3 py-1 bg-accent-100 text-accent-800 text-xs font-semibold rounded-full mb-5 whitespace-nowrap">
                <i className="ri-article-line"></i>
                Expert Guides
              </span>
              <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 text-balance">
                Hipobuy Spreadsheet Resources
              </h2>
              <p className="text-base text-foreground-500 mt-2">
                In-depth guides, reviews, and tips to master spreadsheet shopping
              </p>
            </div>
            <a
              href="/hipobuy-spreadsheet-guide"
              className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer"
            >
              View All Guides
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {articles.slice(0, 6).map((article) => (
              <a
                key={article.id}
                href={`/${article.slug}`}
                className="group block rounded-2xl border border-background-200/60 bg-background-50 overflow-hidden hover:border-primary-300 transition-all duration-200 cursor-pointer"
              >
                <div className="aspect-[16/10] overflow-hidden bg-background-100">
                  <img
                    src={article.image}
                    alt={article.title}
                    title={`${article.title} - Hipobuy Spreadsheet`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="text-xs font-semibold px-2.5 py-1 rounded-full bg-accent-100 text-accent-800 whitespace-nowrap">
                      {article.category}
                    </span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{article.readTime}</span>
                  </div>
                  <h3 className="font-heading text-lg font-bold text-foreground-950 group-hover:text-primary-600 transition-colors duration-200 mb-2 line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center gap-2 mt-4 text-xs text-foreground-400">
                    <i className="ri-calendar-line"></i>
                    <span>{article.date}</span>
                  </div>
                </div>
              </a>
            ))}
          </div>

          {articles.length > 6 && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
              {articles.slice(6).map((article) => (
                <a
                  key={article.id}
                  href={`/${article.slug}`}
                  className="group block rounded-2xl border border-background-200/60 bg-background-50 overflow-hidden hover:border-primary-300 transition-all duration-200 cursor-pointer"
                >
                  <div className="aspect-[16/10] overflow-hidden bg-background-100">
                    <img
                      src={article.image}
                      alt={article.title}
                      title={`${article.title} - Hipobuy Spreadsheet`}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-5">
                    <div className="flex items-center gap-3 mb-3">
                      <span className="text-xs font-semibold px-2.5 py-1 rounded-full bg-accent-100 text-accent-800 whitespace-nowrap">
                        {article.category}
                      </span>
                      <span className="text-xs text-foreground-400 whitespace-nowrap">{article.readTime}</span>
                    </div>
                    <h3 className="font-heading text-lg font-bold text-foreground-950 group-hover:text-primary-600 transition-colors duration-200 mb-2 line-clamp-2">
                      {article.title}
                    </h3>
                    <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center gap-2 mt-4 text-xs text-foreground-400">
                      <i className="ri-calendar-line"></i>
                      <span>{article.date}</span>
                    </div>
                  </div>
                </a>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}